import React from 'react';
import PropTypes from 'prop-types';
import notificationReducer from './reducer';

export const INITIAL_STATE = {
  open: false,
  notifications: {
    items: [],
    loading: false,
    error: false,
    success: false,
  },
  current: {
    id: null,
    loading: false,
    error: false,
    data: {
      operations: [],
    },
  },
  pilot: false,
};

export const NotificationContext = React.createContext({});
NotificationContext.displayName = 'Notification';

export const NotificationContextProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(notificationReducer, INITIAL_STATE);
  const store = React.useMemo(() => ({ state, dispatch }), [state]);
  return <NotificationContext.Provider value={store}>{children}</NotificationContext.Provider>;
};

export const useNotificationContext = () => {
  const { state, dispatch } = React.useContext(NotificationContext);
  return [state, dispatch];
};

NotificationContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
